module.exports = __webpack_public_path__ + "img/logo_transparent.c238893c.svg";